import stateApi from '@/api/stateApi';
import InspectTabs from '@/components/inspectTabs';
import RootStats from '@/components/rootStats';
import { InspectTabsSearchParams } from '@/lib/inspectLocation';
import { Title } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/inspect/')({
  component: RouteComponent,
  validateSearch: InspectTabsSearchParams,
});

function RouteComponent() {
  const hostname = stateApi.state.useStore((state) => state.actual.host?.name);

  return (
    <InspectTabs
      header={
        <>
          <Title>{hostname}</Title>

          <RootStats />
        </>
      }
    />
  );
}
